export const LOGIN_ROUTE = '/login';
export const PLAYBOOKS_ROUTE = '/playbooks';
export const RUNS_ROUTE = '/runs';
export const AI_KEYS_ROUTE = '/settings/ai-keys';
export const TEST_CONTACTS_ROUTE = '/settings/test-contacts';
export const VERIFY_OTP_ROUTE = '/login/verify-otp';
export const HOME_ROUTE = '/';
export const NO_ACCESS_ROUTE = '/no-access';
